import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import { useDispatch, useSelector } from 'react-redux';
import { setMessageId, setSelectedMsgId } from 'modules/actions/quality';
/**
 * 버튼
 */


const ButtonUnderText = ({ label, value, labelIcon, viewStatus, onClickEvt, contentLength, image, number }) => {
  const changeRadiusBox = contentLength === 6 ? [0,2,3,5]: [];
  const changeSet = contentLength === 6 ? {0: '20px 0px 0px 0px', 2:'0px 20px 0px 0px', 3:'0px 0px 0px 20px', 5:'0px 0px 20px 0px'} : ''
  const isChangeBox = changeRadiusBox.includes(number);
  const imageAddAlt = image.replace('></img>', ' alt="">');
  const dispatch = useDispatch();
  
  // 새 창 열림 속성 추가
  const isLink = value.startsWith('https');
  
  // 연관용어찾기 포커스 돌아가기 위해서 클래스명 수정
  const className = value === '연관용어찾기' ? '_btn_under_txt_div _additional_words_btn' : '_btn_under_txt_div';
  
  const openAdditinalTermModal = (msgId) => {
    if (msgId) {
      dispatch(setSelectedMsgId(msgId));
    }
  };
  
  onClickEvt = (e) => {
    const msgDiv = e.target.closest('div[name]');
    const msgId = msgDiv.getAttribute('name');
    if (msgId) {
      openAdditinalTermModal(msgId);
    } else {
      openAdditinalTermModal();
    }
  };
  
  return (
    <button className={className} style={{borderRadius : isChangeBox ? changeSet[number] :'0px 0px 0px 0px'}}  onClick={onClickEvt} type='button' aria-label={isLink ? label + ' 새 창 열림' : undefined} role={isLink ? 'link' : undefined}>
      {viewStatus === '_dim' ? <div className="_dim" /> : ''}
      <div className="_btn_div">
        <div className="_icon">
          {labelIcon !== 'ri-cloud-line' ? (
            <i className={labelIcon} />
          ) : (
            <div> {image.includes('<img') ? ReactHtmlParser(imageAddAlt) : <img src={image} alt=""/>}</div>
          )}
        </div>
        <div className="_txt">{label}</div>
      </div>
    </button>
  );
};

ButtonUnderText.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  labelIcon: PropTypes.string,
  image: PropTypes.string,
  // styleDef: PropTypes.object,
  viewStatus: PropTypes.string,
  onClickEvt: PropTypes.func,
  // error: PropTypes.object,
  number: PropTypes.number,
  contentLength: PropTypes.number,
};
ButtonUnderText.defaultProps = {
  label: '적용',
  value: '',
  labelIcon: 'ri-cloud-line',
  image: '',
  // styleDef: {},
  viewStatus: '',
  onClickEvt: (e) => { handleClick(e) },
  // error: { error: false, msg: '' },
  number: 0,
  contentLength: 6,
};

export default ButtonUnderText;
